module.exports = __webpack_public_path__ + "static/media/arrow-previous.82d7f9d3.svg";